import script from "./MaterialList.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialList.vue?vue&type=script&setup=true&lang=js"

import "./MaterialList.vue?vue&type=style&index=0&id=c698ceee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c698ceee"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr,QIcon});
